import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { ThemeModes } from './themes';
export const useThemeMode = () => {
  const $ = _c(6);
  const initial_theme = _temp;
  const [theme, setTheme] = useState(initial_theme);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = theme_0 => {
      window.localStorage.setItem("theme", theme_0);
      setTheme(theme_0);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const changeTheme = t0;
  let t1;
  let t2;
  if ($[1] !== theme) {
    t1 = () => {
      window.document.documentElement.setAttribute("data-theme", theme);
    };
    t2 = [theme];
    $[1] = theme;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== theme) {
    t3 = [theme, changeTheme];
    $[4] = theme;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
function _temp() {
  if (typeof window === "undefined") {
    return "system";
  }
  return window.localStorage.getItem("theme") as ThemeModes || "system";
}